module.exports = __webpack_public_path__ + "img/mongolia.4dca864f.svg";